<app-stages [stages]='stages' currentStage='Lokalizacja'></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete='off' novalidate [formGroup]='form' (ngSubmit)='submitAndGoNext()'>
    <br>
    <app-exposed-map-control #mapControl [control]="form.geometry">
    </app-exposed-map-control>
    <app-road-controls-set [expMapDict]="mapControl.dictEvent()" [form]="form"></app-road-controls-set>
    <br>
    <fieldset>
      <legend>
        Działki drogowe
      </legend>
      <app-parcels-crud
        expMapDictPlotType="Drogowa"
        [expMapDict]="mapControl.dictEvent()"
        tag="parcels"
        formControlName="parcels">
      </app-parcels-crud>
    </fieldset>
    <fieldset>
      <legend>
        Działki przylegające do działek drogowych
      </legend>
      <app-parcels-crud
        expMapDictPlotType="Powiązana"
        [expMapDict]="mapControl.dictEvent()"
        tag="parcels2"
        formControlName="parcels2">
      </app-parcels-crud>
    </fieldset>
    <div class="row">
      <div class="col-12">
        <div class='form-group' *ngIf='"description" as controlName'>
          <label [for]='controlName'>
            Wskazanie sposobu zmiany zagospodarowania terenu przyległego do pasa drogowego (wskazanie rodzaju
            inwestycji) *
          </label>
          <textarea
            rows="8"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Opisz tu wskazanie sposobu zmiany zagospodarowania terenu'>
            </textarea>
          <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <div class='application-actions'>
      <button
        [disabled]='pending()'
        (click)='onCancel()'
        type='button'
        class='btn btn-secondary'>
        <span>
          Wstecz
        </span>
      </button>
      <button
        [disabled]='pending()'
        type='submit'
        class='btn btn-primary'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
